document.addEventListener("DOMContentLoaded", function () {
    const categoryLinks = document.querySelectorAll("#categories a");

    categoryLinks.forEach(link => {
        link.addEventListener("click", function () {
            const targetId = this.getAttribute("href").substring(1);
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
                setTimeout(() => {
                    targetSection.setAttribute("tabindex", "-1");
                    targetSection.focus();
                }, 80);
            }
        });
    });
});